import React from 'react';

interface OrganicSpinnerProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

export const OrganicSpinner: React.FC<OrganicSpinnerProps> = ({ size = 60, color = '#5c1011', style }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-50 -50 100 100"
      style={{
        animation: 'spinSlow 6s linear infinite',
        ...style,
      }}
    >
      <path fill={color} fillOpacity="0.92">
        <animate
          attributeName="d"
          dur="3.2s"
          repeatCount="indefinite"
          values="
            M30,0 C30,16.5 16.5,30 0,30 C-16.5,30 -30,16.5 -30,0 C-30,-16.5 -16.5,-30 0,-30 C16.5,-30 30,-16.5 30,0 Z;
            M34,-6 C28,12 14,32 -4,32 C-22,32 -34,16 -32,-2 C-30,-22 -14,-34 4,-32 C22,-30 38,-22 34,-6 Z;
            M28,8 C36,22 22,34 4,34 C-16,34 -34,18 -30,-2 C-26,-22 -8,-34 10,-30 C28,-26 22,-4 28,8 Z;
            M30,0 C30,16.5 16.5,30 0,30 C-16.5,30 -30,16.5 -30,0 C-30,-16.5 -16.5,-30 0,-30 C16.5,-30 30,-16.5 30,0 Z
          "
        />
      </path>
    </svg>
  );
};

export default OrganicSpinner;
